function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "M0 0H1440V6546H0z",
  transform: "translate(-419 -1532)"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mk40iwsw4a",
  width: 126,
  height: 73,
  x: 9,
  y: 58,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.04 58.25l6.13 46.158c.216 1.623 1.337 2.981 2.888 3.497l62.867 20.922c6.431 2.141 13.446 1.651 19.52-1.362l26.43-13.111c1.293-.641 2.175-1.894 2.345-3.33l5.504-46.345L9.04 58.25z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mk40iwsw4a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D8D8D8",
  d: "M9.04 58.25l6.13 46.158c.216 1.623 1.337 2.981 2.888 3.497l62.867 20.922c6.431 2.141 13.446 1.651 19.52-1.362l26.43-13.111c1.293-.641 2.175-1.894 2.345-3.33l5.504-46.345L9.04 58.25z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M7.439 45.41l83.525 19.02v67.738l-75.44-25.107-8.085-61.65z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M90.964 64.43l45.696-13.843-7.713 62.739-37.983 18.842V64.429z",
  clipRule: "evenodd"
}));

var _ref5 = /*#__PURE__*/React.createElement("mask", {
  id: "o7l6cn9uyb",
  width: 134,
  height: 37,
  x: 5,
  y: 44,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.12 44.433L6.784 58.05c.133 1.086.912 1.982 1.968 2.26l74.965 19.83c4.733 1.252 9.724 1.124 14.387-.367l36.922-11.81c.995-.319 1.714-1.19 1.838-2.23l1.903-15.869L5.12 44.433z"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#o7l6cn9uyb)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D8D8D8",
  d: "M5.12 44.433L6.784 58.05c.133 1.086.912 1.982 1.968 2.26l74.965 19.83c4.733 1.252 9.724 1.124 14.387-.367l36.922-11.81c.995-.319 1.714-1.19 1.838-2.23l1.903-15.869L5.12 44.433z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C5CDDD",
  fillRule: "evenodd",
  d: "M4.544 44.63l86.553 19.134-.133 18.403-82.693-21.86c-1.048-.278-1.824-1.162-1.965-2.239L4.544 44.63z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M91.097 63.764l47.646-13.397-1.906 15.508c-.128 1.039-.849 1.907-1.844 2.223L90.964 82.057l.133-18.293z",
  clipRule: "evenodd"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M123.268 55.153l2.126-1.2.276 17.413h-2.402V55.153z",
  clipRule: "evenodd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C1",
  fillRule: "evenodd",
  d: "M124.86 53.848v16.636c3.044-.665 4.566-.283 4.566 1.146 0 1.43 2.012-.035 6.036-4.392l-.481-3.687-4.687-11.17-5.434 1.467z",
  clipRule: "evenodd"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#66759D",
  fillRule: "evenodd",
  d: "M119.247 68.981l14.539-5.81c.685-.273 1.461.062 1.734.748.062.158.094.326.094.495v1.944c0 .543-.328 1.033-.83 1.238l-15.537 6.353V68.98z",
  clipRule: "evenodd"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C1",
  fillRule: "evenodd",
  d: "M110.105 59.115l-.989 17.254c3.044-.308 4.566.252 4.566 1.681 0 1.366 1.919.089 5.757-3.83.35-.358.546-.838.546-1.339v-3.614c0-.292-.067-.58-.195-.842l-5.239-10.694-4.446 1.384z",
  clipRule: "evenodd"
});

var _ref11 = /*#__PURE__*/React.createElement("mask", {
  id: "9eymbxhhjc",
  width: 138,
  height: 27,
  x: 3,
  y: 38,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3.188 38.1v2.946c0 1.985 1.36 3.71 3.288 4.165L83.84 63.53c4.668 1.106 9.543.974 14.145-.382l40.724-11.996c1.136-.334 1.916-1.38 1.916-2.566V42.57l-42.43 13.568c-4.734 1.514-9.787 1.72-14.628.598L3.188 38.1z"
}));

var _ref12 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#9eymbxhhjc)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#D8D8D8",
  d: "M3.188 38.1v2.946c0 1.985 1.36 3.71 3.288 4.165L83.84 63.53c4.668 1.106 9.543.974 14.145-.382l40.724-11.996c1.136-.334 1.916-1.38 1.916-2.566V42.57l-42.43 13.568c-4.734 1.514-9.787 1.72-14.628.598L3.188 38.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M90.648 57.83v8.945l48.249-14.88c1.344-.415 2.261-1.659 2.261-3.068v-6.002c-1.385-1.844-2.516-2.305-3.394-1.383-.878.922-16.584 6.384-47.116 16.387z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DCE2F1",
  fillRule: "evenodd",
  d: "M6.777 37.581l84.32 21.247v9.194L5.585 46.078c-1.584-.406-2.72-1.799-2.804-3.436l-.087-1.697c-.093-1.817 1.301-3.365 3.114-3.459.326-.016.652.016.969.096z",
  clipRule: "evenodd"
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#C0C9DC",
  fillRule: "evenodd",
  d: "M59.455 26.941l78.917 14.106c.725.13 1.209.824 1.079 1.551-.089.505-.459.914-.952 1.053L91.554 56.903c-.212.06-.436.067-.65.019L6.7 38.176c-.432-.096-.704-.525-.608-.958.067-.304.304-.541.607-.609l42.267-9.443c3.447-.77 7.011-.846 10.488-.225z",
  clipRule: "evenodd"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fill: "#B2B9CB",
  fillRule: "evenodd",
  d: "M15.523 39.742l38.06-9.328 79.112 14.019-41.731 14.02-75.44-18.71z",
  clipRule: "evenodd"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  fillRule: "evenodd",
  d: "M3.74 38.932l80.884 18.063v-1.698L5.777 37.537 3.74 38.932z",
  clipRule: "evenodd"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fill: "#95A1C2",
  fillRule: "evenodd",
  d: "M52.125 26.247c.718-.303 2.995-.244 6.83.18l79.564 14.529-.034.022c2.019.585 2.61 1.402 1.774 2.45L92.017 58.445c-.687.214-1.422.224-2.115.03l-5.278-1.48v-1.698l5.319 1.424c.668.179 1.372.169 2.034-.03 9.05-2.712 15.328-4.605 18.835-5.679 9.988-3.058 16.38-5.031 19.174-5.919 2.391-.758 4.539-1.376 5.895-2.194.695-.42 1.202-.867 1.584-1.227l-.231.158c-33.555-5.748-55.966-9.794-67.232-12.137-9.704-2.018-15.388-2.89-17.051-2.617-.238.039-.655.181-.81.162L8.076 36.495c-1.03.285-1.657.498-1.88.64-.337.213.24.595 0 .772-1.061.784-2.142 1.022-2.389 1.022-.537 0-2.268-1.182 2.049-2.434 2.878-.834 18.3-4.252 46.266-10.252l.003.005z",
  clipRule: "evenodd"
});

function SvgTotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145,
    height: 145,
    fill: "none",
    viewBox: "0 0 145 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotes);
export default __webpack_public_path__ + "static/media/totes.b2ade1c9.svg";
export { ForwardRef as ReactComponent };